import * as MatchStatus from 'customer-data-filters-ui/filterQueryFormat/MatchStatus';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
export const matchDataByStatus = {
  [MatchStatus.FAIL]: {
    IconComponent: RemoveIcon,
    iconColor: 'icon-alert-default',
    size: '500'
  },
  [MatchStatus.PASS]: {
    IconComponent: SuccessIcon,
    iconColor: 'fill-positive-default',
    size: '500'
  },
  [MatchStatus.PENDING]: undefined
};